
import HanumanChalisa from './../assets/spiritualPhotos/hanumanji.png'
import ShivJi from './../assets/spiritualPhotos/shivji.jpeg'
import Krishna from './../assets/spiritualPhotos/krishna.jpeg'
import DeviBhajan from './../assets/spiritualPhotos/devi.jpeg'
import Navratri from './../assets/spiritualPhotos/navratri.jpeg'

export const spiritualFilterData = [
    {
        id:11,
        name: 'For You',
        image:''
    },
    {
        id:2,
        name: "Hanuman Chalisa",
        image:HanumanChalisa
    },
    {
        id:4,
        name:'Shiv Bhajans',
        image: ShivJi,
    },
    {
        id:5,
        name:'Devi Bhajans',
        image: DeviBhajan
    },
    {
        id:1,
        name: "Sawan Special",
        image: ShivJi,
    },
    {
        id:6,
        name:'Navratri Special',
        image:Navratri
    },
    {
        id:7,
        name:'Krishna Bhajan',
        image:Krishna
    }
];